import Interceptor from "../Interceptor"
import Env from '../../services/Env'

export default class SegurancaApiInterceptor {
    private api: any = new Interceptor()
    private config: object = {
        baseURL: Env.API_SEGURANCA,
    }

    delete(url: string): any {
        return this.api.delete(url, this.config)
    }

    get(url: string): any {
        return this.api.get(url, this.config)

    }

    getAllowAnonymous(url: string, extras: object = {}): any {
        return this.api.getAllowAnonymous(url, { ...this.config, ...extras })
    }

    post(url: string, data: any): any {
        return this.api.post(url, data, this.config)
    }

    postAllowAnonymous(url: string, data: any, extras: object = {}): any {
        return this.api.postAllowAnonymous(url, data, { ...this.config, ...extras })
    }

    put(url: string, data: any): any {
        return this.api.put(url, data, this.config)
    }

    upload(url: string, formData: any, headers: any) {
        const configUpload: any = {
            headers,
            baseURL: Env.API_SEGURANCA,
        }
        return this.api.postAllowAnonymous(url, formData, configUpload)
    }

    getBlob(url: string) {
        const configBlob: any = {
            baseURL: Env.API_SEGURANCA,
            responseType: 'blob'
        }
        return this.api.get(url, configBlob)
    }
}